import "@/styles/index.css"

import { ThemeProvider } from "@mui/material"
import StyledEngineProvider from "@mui/material/StyledEngineProvider"
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs"
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider"
import { AllCommunityModule, ModuleRegistry } from "ag-grid-community"
import { StrictMode } from "react"
import ReactDOM from "react-dom/client"

import { DragDropProvider } from "@/providers/DragDropProvider"
import { GraphqlRouterProvider } from "@/providers/GraphqlRouterProvider"
import theme from "@/styles/mui-theme"

ModuleRegistry.registerModules([AllCommunityModule])

// Render the app
const rootElement = document.querySelector(".root")!
if (!rootElement.innerHTML) {
  const root = ReactDOM.createRoot(rootElement)
  root.render(
    <StrictMode>
      <StyledEngineProvider injectFirst>
        <ThemeProvider theme={theme}>
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DragDropProvider>
              <GraphqlRouterProvider />
            </DragDropProvider>
          </LocalizationProvider>
        </ThemeProvider>
      </StyledEngineProvider>
    </StrictMode>
  )
}
